import { ReactNode } from 'react'
import { Box, Radio, Typography } from '@mui/material'
import { SelectableCard } from '@dhl/components'
import type { SelectableCardData } from '~/widgets'
import { SelectableCardIcon } from './SelectableCardIcon'

type Props<T> = {
  item: SelectableCardData<T>
  isSelected: boolean
  onClick: () => void
  testId: string
}

export const SelectableCardItem: <T>(props: Props<T>) => ReactNode = ({ item, isSelected, onClick, testId }) => {
  const { label, description, iconName } = item

  return (
    <SelectableCard isSelected={isSelected} onClick={onClick} data-test={testId}>
      <Box sx={{ lineHeight: '16px', alignItems: 'center', justifyContent: 'center', display: 'flex', height: '100%' }}>
        <Box sx={{ flex: '0 0 90px', display: 'flex', justifyContent: 'center' }}>
          <SelectableCardIcon name={iconName} />
        </Box>
        <Box sx={{ flex: '1 1 auto', paddingTop: 2, paddingBottom: 2 }}>
          <Box sx={{ overflow: 'hidden', minHeight: '22px' }}>
            <Typography variant="h5">{label}</Typography>
          </Box>
          <Box sx={{ overflow: 'hidden' }}>
            <Typography variant="body2">{description}</Typography>
          </Box>
        </Box>
        <Box
          sx={({ spacing }) => ({
            flex: '0 1px 50px',
            display: 'flex',
            justifyContent: 'center',
            paddingRight: spacing(1),
          })}
        >
          <Radio
            color="default"
            checked={isSelected}
            inputProps={{ 'aria-label': 'A' }}
            sx={({ palette: { grey } }) => ({
              root: {
                color: grey[500],
              },
              checked: {
                color: grey[700],
              },
            })}
          />
        </Box>
      </Box>
    </SelectableCard>
  )
}
